export const isPrivateRoute = (path: string): boolean =>
  /^\/(account|checkout|auth|sign-in|basket|me)(\/|$)/.test(path);
